<template>
  <div>
    <NavigationBar />
    <div class="container mt-3">
      <StammdatenTable 
        ref="tableComponent" 
        :config="tableConfig" 
        :configKey="type" 
        @edit-start="handleEditStart" 
      />
    </div>
  </div>
</template>

<script>
import StammdatenTable from '@/components/StammdatenTable.vue';
import NavigationBar from '@/views/NavigationBar.vue';
import { config } from '@/stammdatenConfig';

export default {
  name: 'StammdatenView',
  props: ['type'],
  components: { StammdatenTable, NavigationBar },
  computed: {
    tableConfig() {
      return config[this.type] || { title: 'Ismeretlen típus', fields: [], api: {} };
    }
  },
  methods: {
    handleEditStart(row) {
      console.log('[StammdatenView] Bearbeitung gestartet für:', row);
      const index = this.$refs.tableComponent?.data.findIndex(r => r.az === row.az);
      if (index !== -1) {
        const fullOriginal = { ...this.$refs.tableComponent.data[index], ...row };
        this.$refs.tableComponent.data[index] = JSON.parse(JSON.stringify(fullOriginal));
        console.log('[StammdatenView] Komplettes Objekt kopiert:', this.$refs.tableComponent.data[index]);
      } else {
        console.warn('[StammdatenView] Zeile nicht gefunden für az:', row.az);
      }
    }
  }
};
</script>